import { useEffect } from 'react';
import type { Editor as TiptapEditor } from '@tiptap/core';

const useEscapeKey = (isOpen: boolean, onClose: () => void, editor?: TiptapEditor) => {
  useEffect(() => {
    if (!isOpen) return;

    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        onClose();
      }
    };

    // Listen on both iframe window (for when focus is in editor) and parent document
    // (for when focus is in popover/dialog)
    const iframeWindow = editor?.view.dom.ownerDocument.defaultView;
    iframeWindow?.addEventListener('keydown', handleEscape);
    document.addEventListener('keydown', handleEscape);
    return () => {
      iframeWindow?.removeEventListener('keydown', handleEscape);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose, editor]);
};

export default useEscapeKey;
